module.exports = __webpack_public_path__ + "img/icon54.cd67a4e7.png";